import { Link } from "react-router-dom";
import { TTableData } from "../Simulation";

const BASE_CLASS = "tablesSimulation"

type TTableSimulationProps = {
    data: TTableData[]
}

const TableOrigen: React.FC<TTableSimulationProps> = ({ data }) => {
    const localTheme = window.localStorage.getItem("theme") || "light";
    return (
        <div className={BASE_CLASS}>
            <table>
                <thead>
                    <tr className={`${BASE_CLASS}__${localTheme}`}>
                        <th>Fondo Original</th>
                        <th>Peso</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((item, index) => {
                        return (
                            <tr key={index}>
                                <Link to={`/${item.originalIsin}`}>
                                    <td>
                                        {item.originalName}
                                        <br />
                                        <span className={`${BASE_CLASS}__origenIsin`}>{item.originalIsin}</span>
                                    </td>
                                </Link>
                                <td className={`${BASE_CLASS}__center__text`}>
                                    <p>{item.originalWeight.toFixed(2)}%</p>
                                </td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        </div>
    )
};

export default TableOrigen;